"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processStream = exports.AssistantStreamEmitter = void 0;
const eventemitter3_1 = __importDefault(require("eventemitter3"));
const Ai_1 = require("../types/responses/Ai");
class AssistantStreamEmitter extends eventemitter3_1.default {
}
exports.AssistantStreamEmitter = AssistantStreamEmitter;
const processStream = (stream) => {
    const eventsEmitter = new AssistantStreamEmitter();
    const reader = stream.getReader();
    const decoder = new TextDecoder('utf-8');
    let generatedContent = '';
    let startReadingCalled = false;
    let bufferedEvent = '';
    function readChunk() {
        reader
            .read()
            .then(({ done, value }) => {
            if (done) {
                reader.releaseLock();
                return;
            }
            const event = decoder.decode(value, { stream: true });
            bufferedEvent += event;
            const events = bufferedEvent.split('\n\n<END_OF_EVENT>\n');
            bufferedEvent = events.pop() || '';
            for (const currentEvent of events) {
                if (!currentEvent.trim()) {
                    continue;
                }
                const eventPayload = currentEvent.split('\ndata: ');
                const eventType = eventPayload[0].replace('event: ', '').trim();
                const eventData = eventPayload.length > 1 ? eventPayload.slice(1).join('\ndata: ') : undefined;
                let hasParsedData = false;
                let parsedData;
                const requireParsedData = () => {
                    if (!eventData) {
                        throw new Error(`Missing data for event type: ${eventType}`);
                    }
                    if (!hasParsedData) {
                        parsedData = JSON.parse(eventData);
                        hasParsedData = true;
                    }
                    return parsedData;
                };
                try {
                    switch (eventType) {
                        case Ai_1.StreamAIEventType.MESSAGE_CHUNK: {
                            const data = requireParsedData();
                            generatedContent += data.chunk;
                            eventsEmitter.emit(Ai_1.StreamAIEventType.MESSAGE_CHUNK, data);
                            break;
                        }
                        case Ai_1.StreamAIEventType.METADATA: {
                            eventsEmitter.emit(Ai_1.StreamAIEventType.METADATA, requireParsedData());
                            break;
                        }
                        case Ai_1.StreamAIEventType.TITLE_UPDATE: {
                            eventsEmitter.emit(Ai_1.StreamAIEventType.TITLE_UPDATE, requireParsedData());
                            break;
                        }
                        case Ai_1.StreamAIEventType.MESSAGE_METADATA: {
                            eventsEmitter.emit(Ai_1.StreamAIEventType.MESSAGE_METADATA, requireParsedData());
                            break;
                        }
                        case Ai_1.StreamAIEventType.DOCUMENT_START: {
                            eventsEmitter.emit(Ai_1.StreamAIEventType.DOCUMENT_START);
                            break;
                        }
                        case Ai_1.StreamAIEventType.DOCUMENT_TITLE: {
                            eventsEmitter.emit(Ai_1.StreamAIEventType.DOCUMENT_TITLE, requireParsedData());
                            break;
                        }
                        case Ai_1.StreamAIEventType.DOCUMENT_CHUNK: {
                            eventsEmitter.emit(Ai_1.StreamAIEventType.DOCUMENT_CHUNK, requireParsedData());
                            break;
                        }
                        case Ai_1.StreamAIEventType.DOCUMENT_END: {
                            eventsEmitter.emit(Ai_1.StreamAIEventType.DOCUMENT_END);
                            break;
                        }
                        case Ai_1.StreamAIEventType.DOCUMENT_METADATA: {
                            eventsEmitter.emit(Ai_1.StreamAIEventType.DOCUMENT_METADATA, requireParsedData());
                            break;
                        }
                        case Ai_1.StreamAIEventType.DOCUMENT_ERROR: {
                            eventsEmitter.emit(Ai_1.StreamAIEventType.DOCUMENT_ERROR);
                            break;
                        }
                        case Ai_1.StreamAIEventType.TOOL_USE_GENERATION_START: {
                            eventsEmitter.emit(Ai_1.StreamAIEventType.TOOL_USE_GENERATION_START, requireParsedData());
                            break;
                        }
                        case Ai_1.StreamAIEventType.TOOL_USE_GENERATION_END: {
                            eventsEmitter.emit(Ai_1.StreamAIEventType.TOOL_USE_GENERATION_END, requireParsedData());
                            break;
                        }
                        case Ai_1.StreamAIEventType.TOOL_USE_EXECUTION_START: {
                            eventsEmitter.emit(Ai_1.StreamAIEventType.TOOL_USE_EXECUTION_START, requireParsedData());
                            break;
                        }
                        case Ai_1.StreamAIEventType.TOOL_USE_EXECUTION_END: {
                            eventsEmitter.emit(Ai_1.StreamAIEventType.TOOL_USE_EXECUTION_END, requireParsedData());
                            break;
                        }
                        case Ai_1.StreamAIEventType.DONE:
                            eventsEmitter.emit(Ai_1.StreamAIEventType.DONE);
                            break;
                        default:
                            break;
                    }
                }
                catch (error) {
                    reader.releaseLock();
                    eventsEmitter.emit(Ai_1.StreamAIEventType.ERROR, {
                        error,
                        generatedContent,
                    });
                    return;
                }
            }
            readChunk();
        })
            .catch((error) => {
            reader.releaseLock();
            eventsEmitter.emit(Ai_1.StreamAIEventType.ERROR, { error, generatedContent });
        });
    }
    function startReading() {
        if (!startReadingCalled) {
            startReadingCalled = true;
            readChunk();
        }
    }
    setTimeout(() => {
        if (!startReadingCalled) {
            startReading();
        }
    }, 0);
    return {
        stream,
        events: eventsEmitter,
        startReading,
    };
};
exports.processStream = processStream;
